module.exports = __webpack_public_path__ + "static/media/whisky_distillery_tablet.7564f265.jpg";